/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: -QRs2TcdyJW6
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import SideNav from "../../SideNav"; // plasmic-import: ALhfiVPnGgY_/component
import ModuleNav from "../../ModuleNav"; // plasmic-import: 9QJHZ6j77LRS/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: WzCWRCw5Fj7M/component
import PageLayout from "../../PageLayout"; // plasmic-import: CF9w0NRrnxvp/component
import SectionHero from "../../SectionHero"; // plasmic-import: LAgK4hEGm2TV/component
import TopNav from "../../TopNav"; // plasmic-import: MzgISFkf8fEm/component
import ButtonPage from "../../ButtonPage"; // plasmic-import: voJV0X1zqcH0/component
import Paragraph from "../../Paragraph"; // plasmic-import: kgnuU3lABlxV/component
import SectionFooter from "../../SectionFooter"; // plasmic-import: NAltgsviawN1/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicEarlyBird.module.css"; // plasmic-import: -QRs2TcdyJW6/css
import image30Ora4HOUuN6U from "./images/image30.svg"; // plasmic-import: ORA4H_oUuN6u/picture

createPlasmicElementProxy;

export const PlasmicEarlyBird__VariantProps = new Array();

export const PlasmicEarlyBird__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicEarlyBird__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "firstNameVariant",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "normal"
      },
      {
        path: "lastNameVariant",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "normal"
      },
      {
        path: "emailVariant",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "normal"
      },
      {
        path: "firstNameHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "lastNameHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "emailHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "firstNameHelperTextOn",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "lastNameHelperTextOn",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "emailHelperTextOn",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "firstNameInputValue",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "lastNameInputValue",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "emailInputValue",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "isCheckedYes",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "isCheckedNo",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "showTitleCredentials",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "yesClickCount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      },
      {
        path: "noClickCount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      },
      {
        path: "firstNameValid",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "lastNameValid",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "lastNameCheck",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      },
      {
        path: "firstNameCheck",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      },
      {
        path: "showFormStatus",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "emailCheck",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      },
      {
        path: "emailValid",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "yesNoError",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "normal"
      },
      {
        path: "yesNoHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "yesNoHelperTextOn",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "yesNoClickCount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"pageHome"}
          data-plasmic-override={overrides.pageHome}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.pageHome
          )}
        >
          <div
            data-plasmic-name={"stikySidenavWrapper"}
            data-plasmic-override={overrides.stikySidenavWrapper}
            className={classNames(projectcss.all, sty.stikySidenavWrapper)}
          >
            <SideNav
              data-plasmic-name={"sideNav"}
              data-plasmic-override={overrides.sideNav}
              backButton={
                <ModuleNav
                  data-plasmic-name={"moduleNav"}
                  data-plasmic-override={overrides.moduleNav}
                  className={classNames("__wab_instance", sty.moduleNav)}
                  navButtonSlot={
                    <ButtonNav
                      data-plasmic-name={"buttonNav"}
                      data-plasmic-override={overrides.buttonNav}
                      className={classNames("__wab_instance", sty.buttonNav)}
                      iconForButton={
                        <PlasmicImg__
                          data-plasmic-name={"img"}
                          data-plasmic-override={overrides.img}
                          alt={""}
                          className={classNames(sty.img)}
                          displayHeight={"100%"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"none"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"100%"}
                          loading={"lazy"}
                          src={{
                            src: image30Ora4HOUuN6U,
                            fullWidth: 20,
                            fullHeight: 20,
                            aspectRatio: undefined
                          }}
                        />
                      }
                      onClick={async () => {
                        const $steps = {};
                        $steps["goToTop"] = true
                          ? (() => {
                              const actionArgs = { destination: "#top" };
                              return (({ destination }) => {
                                if (
                                  typeof destination === "string" &&
                                  destination.startsWith("#")
                                ) {
                                  document
                                    .getElementById(destination.substr(1))
                                    .scrollIntoView({ behavior: "smooth" });
                                } else {
                                  location.assign(destination);
                                }
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["goToTop"] != null &&
                          typeof $steps["goToTop"] === "object" &&
                          typeof $steps["goToTop"].then === "function"
                        ) {
                          $steps["goToTop"] = await $steps["goToTop"];
                        }
                      }}
                      shape={"fullRounding"}
                    />
                  }
                />
              }
              className={classNames("__wab_instance", sty.sideNav)}
            />
          </div>
          <PageLayout
            data-plasmic-name={"pageLayout"}
            data-plasmic-override={overrides.pageLayout}
            className={classNames("__wab_instance", sty.pageLayout)}
            content={
              <React.Fragment>
                <SectionHero
                  data-plasmic-name={"sectionHero"}
                  data-plasmic-override={overrides.sectionHero}
                  className={classNames("__wab_instance", sty.sectionHero)}
                  colWidth={"medium"}
                  navbar={
                    <TopNav
                      data-plasmic-name={"topNav"}
                      data-plasmic-override={overrides.topNav}
                      className={classNames("__wab_instance", sty.topNav)}
                      pageButtons={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___1Y9Iu
                            )}
                          >
                            {"["}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__gZeHw
                            )}
                            content={"overview"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerOverview"] = true
                                ? (() => {
                                    const actionArgs = { destination: `/` };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerOverview"] != null &&
                                typeof $steps["goToPartnerOverview"] ===
                                  "object" &&
                                typeof $steps["goToPartnerOverview"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerOverview"] =
                                  await $steps["goToPartnerOverview"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__iN9LS
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__ihj1T
                            )}
                            content={"mission"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerMission"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/mission`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerMission"] != null &&
                                typeof $steps["goToPartnerMission"] ===
                                  "object" &&
                                typeof $steps["goToPartnerMission"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerMission"] =
                                  await $steps["goToPartnerMission"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___1ROd
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__hZoTg
                            )}
                            content={"the independent"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerOpenCall"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/the-independent`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerOpenCall"] != null &&
                                typeof $steps["goToPartnerOpenCall"] ===
                                  "object" &&
                                typeof $steps["goToPartnerOpenCall"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerOpenCall"] =
                                  await $steps["goToPartnerOpenCall"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__wbDxt
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__vdoq0
                            )}
                            content={"early bird"}
                            isSelected={true}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToEarlyBird"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/early-bird`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToEarlyBird"] != null &&
                                typeof $steps["goToEarlyBird"] === "object" &&
                                typeof $steps["goToEarlyBird"].then ===
                                  "function"
                              ) {
                                $steps["goToEarlyBird"] =
                                  await $steps["goToEarlyBird"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__zMozP
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__vv1Qq
                            )}
                            content={"contact"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComSupport"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: "https://o21p.com/support"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComSupport"] != null &&
                                typeof $steps["goToHttpsO21PComSupport"] ===
                                  "object" &&
                                typeof $steps["goToHttpsO21PComSupport"]
                                  .then === "function"
                              ) {
                                $steps["goToHttpsO21PComSupport"] =
                                  await $steps["goToHttpsO21PComSupport"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__ft5MT
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__c5VM
                            )}
                            content={"join the community"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComPartnersCommunity"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination:
                                        "https://o21p.com/partners-community"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComPartnersCommunity"] !=
                                  null &&
                                typeof $steps[
                                  "goToHttpsO21PComPartnersCommunity"
                                ] === "object" &&
                                typeof $steps[
                                  "goToHttpsO21PComPartnersCommunity"
                                ].then === "function"
                              ) {
                                $steps["goToHttpsO21PComPartnersCommunity"] =
                                  await $steps[
                                    "goToHttpsO21PComPartnersCommunity"
                                  ];
                              }
                            }}
                            textColor={"brand"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__rvO8A
                            )}
                          >
                            {"]"}
                          </div>
                        </React.Fragment>
                      }
                    />
                  }
                  sectionId={"top"}
                  slot={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__s5R47
                      )}
                    >
                      {"Buy o21p credits before launch and get bonus credits."}
                    </div>
                  }
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__v4PhG
                    )}
                  >
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "var(--token-IDhxDZaSXazc)" }}
                      >
                        {"the early bird program."}
                      </span>
                    </React.Fragment>
                  </div>
                </SectionHero>
                <section
                  data-plasmic-name={"s1"}
                  data-plasmic-override={overrides.s1}
                  className={classNames(projectcss.all, sty.s1)}
                >
                  <div
                    data-plasmic-name={"container"}
                    data-plasmic-override={overrides.container}
                    className={classNames(projectcss.all, sty.container)}
                  >
                    <div
                      data-plasmic-name={"wrapperDiv"}
                      data-plasmic-override={overrides.wrapperDiv}
                      className={classNames(projectcss.all, sty.wrapperDiv)}
                    >
                      <Paragraph
                        data-plasmic-name={"paragraph"}
                        data-plasmic-override={overrides.paragraph}
                        className={classNames("__wab_instance", sty.paragraph)}
                        p={
                          <p
                            data-plasmic-name={"p"}
                            data-plasmic-override={overrides.p}
                            className={classNames(
                              projectcss.all,
                              projectcss.p,
                              projectcss.__wab_text,
                              sty.p
                            )}
                          >
                            {
                              "\u201cAll worthwhile journeys are long. And they all begin with a first step.\u201d"
                            }
                          </p>
                        }
                      />
                    </div>
                  </div>
                </section>
                <SectionFooter
                  data-plasmic-name={"sectionFooter"}
                  data-plasmic-override={overrides.sectionFooter}
                  className={classNames("__wab_instance", sty.sectionFooter)}
                  layout={"withOffset"}
                  sectionId={"footer"}
                />
              </React.Fragment>
            }
            layoutSections={"withNav"}
          />

          {(hasVariant(globalVariants, "screen", "tablet") ? true : false) ? (
            <div
              data-plasmic-name={"noBudgetSmallScreens"}
              data-plasmic-override={overrides.noBudgetSmallScreens}
              className={classNames(projectcss.all, sty.noBudgetSmallScreens)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__p9HEl
                )}
              >
                {"o21p"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__vDtT
                )}
              >
                {
                  "our massive development budget is dedicated to designing and building the platform for larger screens."
                }
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__qoYzz
                )}
              >
                {"\u2013 at least 900px wide \u2013"}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageHome: [
    "pageHome",
    "stikySidenavWrapper",
    "sideNav",
    "moduleNav",
    "buttonNav",
    "img",
    "pageLayout",
    "sectionHero",
    "topNav",
    "s1",
    "container",
    "wrapperDiv",
    "paragraph",
    "p",
    "sectionFooter",
    "noBudgetSmallScreens"
  ],

  stikySidenavWrapper: [
    "stikySidenavWrapper",
    "sideNav",
    "moduleNav",
    "buttonNav",
    "img"
  ],

  sideNav: ["sideNav", "moduleNav", "buttonNav", "img"],
  moduleNav: ["moduleNav", "buttonNav", "img"],
  buttonNav: ["buttonNav", "img"],
  img: ["img"],
  pageLayout: [
    "pageLayout",
    "sectionHero",
    "topNav",
    "s1",
    "container",
    "wrapperDiv",
    "paragraph",
    "p",
    "sectionFooter"
  ],

  sectionHero: ["sectionHero", "topNav"],
  topNav: ["topNav"],
  s1: ["s1", "container", "wrapperDiv", "paragraph", "p"],
  container: ["container", "wrapperDiv", "paragraph", "p"],
  wrapperDiv: ["wrapperDiv", "paragraph", "p"],
  paragraph: ["paragraph", "p"],
  p: ["p"],
  sectionFooter: ["sectionFooter"],
  noBudgetSmallScreens: ["noBudgetSmallScreens"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEarlyBird__ArgProps,
          internalVariantPropNames: PlasmicEarlyBird__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEarlyBird__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageHome") {
    func.displayName = "PlasmicEarlyBird";
  } else {
    func.displayName = `PlasmicEarlyBird.${nodeName}`;
  }
  return func;
}

export const PlasmicEarlyBird = Object.assign(
  // Top-level PlasmicEarlyBird renders the root element
  makeNodeComponent("pageHome"),
  {
    // Helper components rendering sub-elements
    stikySidenavWrapper: makeNodeComponent("stikySidenavWrapper"),
    sideNav: makeNodeComponent("sideNav"),
    moduleNav: makeNodeComponent("moduleNav"),
    buttonNav: makeNodeComponent("buttonNav"),
    img: makeNodeComponent("img"),
    pageLayout: makeNodeComponent("pageLayout"),
    sectionHero: makeNodeComponent("sectionHero"),
    topNav: makeNodeComponent("topNav"),
    s1: makeNodeComponent("s1"),
    container: makeNodeComponent("container"),
    wrapperDiv: makeNodeComponent("wrapperDiv"),
    paragraph: makeNodeComponent("paragraph"),
    p: makeNodeComponent("p"),
    sectionFooter: makeNodeComponent("sectionFooter"),
    noBudgetSmallScreens: makeNodeComponent("noBudgetSmallScreens"),
    // Metadata about props expected for PlasmicEarlyBird
    internalVariantProps: PlasmicEarlyBird__VariantProps,
    internalArgProps: PlasmicEarlyBird__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "o21p early bird.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicEarlyBird;
/* prettier-ignore-end */
